import { render, staticRenderFns } from "./PushRule.vue?vue&type=template&id=1fd76bcd&scoped=true&"
import script from "./PushRule.vue?vue&type=script&lang=js&"
export * from "./PushRule.vue?vue&type=script&lang=js&"
import style0 from "./PushRule.vue?vue&type=style&index=0&id=1fd76bcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd76bcd",
  null
  
)

export default component.exports